<template>
  <div class="usFundsDetail">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.nickName" placeholder="用户昵称" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.phone" placeholder="用户手机号" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllUsFunds">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                style="margin:auto;width:calc(100% - 30px)" height="693" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="客户ID"  align="center" width="200" prop="usId"></el-table-column>
        <el-table-column label="客户昵称" align="center" prop="nickName"></el-table-column>
        <el-table-column label="客户来源" align="center" prop="dentis"></el-table-column>
        <el-table-column label="客户手机号" align="center" prop="usPhone"></el-table-column>
        <el-table-column label="已消费金额" align="center" prop="usRealPay"></el-table-column>
        <el-table-column label="待支付金额" align="center" prop="usWaitPay"></el-table-column>
        <el-table-column label="累计优惠金额" align="center" prop="usDiscountMoney"></el-table-column>
        <el-table-column label="已退款金额" align="center" prop="usRefundMoney"></el-table-column>
        <el-table-column label="购买会员" align="usVip" prop="usVip"></el-table-column>
        <el-table-column label="购买优惠券" align="usCoupon" prop="usCoupon"></el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
  </div>
</template>

<script>
import {bcCapitalDetail} from '../../../api/accountFunds/usfundsdetail'
export default {
  name: 'UsFundsDetail',
  data () {
    return {
      request: {
        nickName: '',
        phone: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 20},
      response: {data: [], total: 0},
      loading: false,
    }
  },
  methods: {
    getAllUsFunds(){
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      bcCapitalDetail(this.request).then(result => {
        this.response.data = result.data.records;
        this.response.total = result.data.total
      })
    },
    reset(){
      this.request.phone = "";
      this.request.nickName = "";
      this.query.current = 1;
      this.getAllUsFunds();
    },
    currenChangeHandle(value){
      this.query.current = value;
      this.getAllUsFunds()
    }
  },
  created() {
    this.getAllUsFunds()
  }
}
</script>

<style scoped>
.usFundsDetail {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/usfundsdetail.vue